import { Helmet } from 'react-helmet';

const RubaaiHelmet = ({ 
  title = "Rubaai - Digital Payment Solutions", 
  description = "Rubaai is a leading digital payment platform offering secure, fast, and reliable payment solutions for businesses and individuals. Experience seamless transactions with our innovative technology.",
  keywords = "digital payments, payment gateway, online payments, mobile payments, fintech, payment solutions, Rubaai",
  image = "/favicon.png",
  url = "https://rubaai.net"
}) => {
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Rubaai" />
      <meta name="robots" content="index, follow" />
      
      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`${url}${image}`} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Rubaai" />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${url}${image}`} />
      <meta name="twitter:site" content="@rubaai" />
      <meta name="twitter:creator" content="@rubaai" />
      
      {/* Additional Meta Tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
      <meta name="theme-color" content="#000000" />
      <meta name="msapplication-TileColor" content="#000000" />
      <meta name="msapplication-config" content="/browserconfig.xml" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
      
      {/* Favicon and Icons */}
      <link rel="icon" href="/favicon.png" />
      <link rel="apple-touch-icon" href="/favicon.png" />
      <link rel="manifest" href="/manifest.json" />
      
      {/* Preconnect for Performance */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      
      {/* Structured Data for SEO */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Rubaai",
          "url": "https://rubaai.net",
          "logo": "https://rubaai.net/favicon.png", 
          "description": "Leading digital payment platform offering secure, fast, and reliable payment solutions",
          "sameAs": [
            "https://twitter.com/rubaai",
            "https://linkedin.com/company/rubaai",
            "https://facebook.com/rubaai"
          ],
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+1-XXX-XXX-XXXX",
            "contactType": "customer service"
          }
        })}
      </script>
    </Helmet>
  );
};

export default RubaaiHelmet; 